import { useQuery } from "@apollo/client";
import type {
  StoreSearchQuery,
  StoreSearchQueryVariables,
} from "../../../__generated__/graphql";
import { STORE_SEARCH } from "../../../api/store-queries";
import { useLocation } from "../../../core/location-provider";

export function useStoreSearch(debouncedKeyword: string) {
  const { hasLastLo, getLocationFromStorage } = useLocation();
  const coords = hasLastLo ? getLocationFromStorage() : { lat: null, lng: null };

  const { data, loading, refetch } = useQuery<
    StoreSearchQuery,
    StoreSearchQueryVariables
  >(STORE_SEARCH, {
    variables: {
      keyword: debouncedKeyword,
      lat: coords.lat,
      lng: coords.lng,
    },
    skip: !debouncedKeyword,
    fetchPolicy: "cache-first",
  });

  return { data, loading, refetch };
}
